// extracted by mini-css-extract-plugin
export var wrap = "ScrollingWrap-module--wrap--cj8dP";
export var initial_focused_content = "ScrollingWrap-module--initial_focused_content--rYU42";
export var trigger = "ScrollingWrap-module--trigger--yWL7A";
export var base = "ScrollingWrap-module--base---r6v9";